import React from 'react';
import { ReactComponent as CustomProductGridTileIcon } from 'qs-assets/Media/ic_product_grid_tile_icon.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <CustomProductGridTileIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
